import React, { useState } from 'react'
import styled from 'styled-components'
import { light } from '~/constants/theme'
import TranscriptStatisticsPanel from '~/pages/CallAnalytics/Transcription/Statistics/TranscriptStatisticsPanel'
import TranscriptAudioView from '~/pages/CallAnalytics/Transcription/TranscriptAudioView'
import TranscriptionLog from '~/pages/CallAnalytics/Transcription/TranscriptionLog'
import { CallTranscript } from '~/types/CallTranscript'

const TranscriptionViewWrapper = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  -webkit-box-flex: 1;
  background-color: ${light.gray200};
`

const Column = styled.div`
  display: flex;
  flex: 1;
  -webkit-box-flex: 1;
  flex-direction: column;
`

const Line = styled.div`
  display: flex;
  width: 100%;
  border: 1px solid ${light.gray400};
`
const LogPanelWrapper = styled.div`
  display: flex;
  flex: 1;
  -webkit-box-flex: 1;
  overflow-y: scroll;
  min-width: 900px;
`

const StatisticsWrapper = styled.div`
  display: flex;
  min-width: 345px;
`

interface TranscriptViewProps {
  onClosed: () => void
  recordingUri: string
  callTranscript: CallTranscript
}
export const TranscriptionView = ({
  recordingUri,
  callTranscript,
}: TranscriptViewProps) => {
  //setup required player states
  const [isAudioPlaying, setIsAudioPlaying] = useState(false)
  const [playerPosition, setPlayerPosition] = useState(0)
  const [requestedTimestamp, setRequestedTimestamp] = useState<number>()

  const handlePlayStateChange = (isPlaying: boolean) => {
    setIsAudioPlaying(isPlaying)
  }
  const handlePlayerPositionChange = (position: number) => {
    setPlayerPosition(position)
  }
  const setPlayerTime = (millis) => {
    setRequestedTimestamp(millis)
  }
  const handlePlay = (time?: number) => {
    if (time !== undefined) {
      setPlayerTime(time)
    }
    setIsAudioPlaying(true)
  }
  const handlePause = () => {
    setIsAudioPlaying(false)
  }

  return (
    <TranscriptionViewWrapper data-testid="transcription-view">
      <Column>
        <TranscriptAudioView
          audioUri={recordingUri}
          callTranscript={callTranscript}
          requestedTimestamp={requestedTimestamp}
          requestedIsPlaying={isAudioPlaying}
          onAudioPlayerPositionChange={handlePlayerPositionChange}
          onAudioPlayStateChange={handlePlayStateChange}
        />
        <Line />
        <LogPanelWrapper>
          <TranscriptionLog
            transcriptionData={callTranscript}
            isPlaying={isAudioPlaying}
            playerPosition={playerPosition}
            onPlay={handlePlay}
            onPause={handlePause}
          />
          <StatisticsWrapper>
            <TranscriptStatisticsPanel transcript={callTranscript} />
          </StatisticsWrapper>
        </LogPanelWrapper>
      </Column>
    </TranscriptionViewWrapper>
  )
}
